import { useReducer } from "react";
import { useStateTransition, useDevtools } from "./hooks";
import { transition } from "./utils";
export const usePromise = (cb, deps = []) => {
    const promiseReducer = useReducer((prevState, action) => transition(prevState, action, {
        PENDING: {
            RESOLVE: (_, { value }) => ({
                state: "RESOLVED",
                value,
            }),
            REJECT: (_, { error }) => ({
                state: "REJECTED",
                error,
            }),
        },
        RESOLVED: {
            EXECUTE: () => ({
                state: "PENDING",
            }),
        },
        REJECTED: {
            EXECUTE: () => ({
                state: "PENDING",
            }),
        },
    }), {
        state: "PENDING",
    });
    useDevtools(cb.name, promiseReducer);
    const [state, dispatch] = promiseReducer;
    useStateTransition(state, "PENDING", () => {
        cb()
            .then((value) => dispatch({ type: "RESOLVE", value }))
            .catch((error) => dispatch({ type: "REJECT", error }));
    }, deps);
    return [state, () => dispatch({ type: "EXECUTE" })];
};
export const useLazyPromise = (cb, deps = []) => {
    const promiseReducer = useReducer((
    // We use "any" as we can not properly resolve the generic
    prevState, action) => transition(prevState, action, {
        IDLE: {
            EXECUTE: (_, { params }) => ({
                state: "PENDING",
                params,
            }),
        },
        PENDING: {
            RESOLVE: (_, { value }) => ({
                state: "RESOLVED",
                value,
            }),
            REJECT: (_, { error }) => ({
                state: "REJECTED",
                error,
            }),
        },
        RESOLVED: {
            EXECUTE: (_, { params }) => ({
                state: "PENDING",
                params,
            }),
        },
        REJECTED: {
            EXECUTE: (_, { params }) => ({
                state: "PENDING",
                params,
            }),
        },
    }), {
        state: "IDLE",
    });
    useDevtools(cb.name, promiseReducer);
    const [state, dispatch] = promiseReducer;
    useStateTransition(state, "PENDING", ({ params }) => {
        cb(...params)
            .then((value) => dispatch({ type: "RESOLVE", value }))
            .catch((error) => dispatch({ type: "REJECT", error }));
    }, deps);
    return [state, (...params) => dispatch({ type: "EXECUTE", params })];
};
//# sourceMappingURL=tools.js.map